import { Site } from ".";

export default class ProviderUser {
   role?: string;
   site?: Site;
}
